import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TaxCollectionPrintReport = () => {
    const location = useLocation();
    const { grampanchayatName, arthikVarshLabel } = location.state || {};

    useEffect(() => {
        setTimeout(() => {
            window.print();
        }, 500);
    }, []);

    return (
        <div className="bg-white min-h-screen p-8 text-black font-serif">
            <div className="text-center mb-8">
                <h1 className="text-xl font-bold mb-4">
                    ग्रामपंचायत {grampanchayatName || 'इनाम धामणी'} , तालुका मिरज , जिल्हा सांगली.
                </h1>
                <h2 className="text-lg font-bold">
                    पाणीपुरवठा कर वसुली
                </h2>
            </div>

            <div className="max-w-3xl mx-auto">
                <table className="w-full border-collapse border border-black">
                    <thead>
                        <tr>
                            <th className="border border-black px-4 py-2 text-center w-1/3">कराचे नाव</th>
                            <th className="border border-black px-4 py-2 text-center">मागील</th>
                            <th className="border border-black px-4 py-2 text-center">चालु</th>
                            <th className="border border-black px-4 py-2 text-center">एकुण</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="border border-black px-4 py-2">पाणीपट्टी</td>
                            <td className="border border-black px-4 py-2 text-right">0</td>
                            <td className="border border-black px-4 py-2 text-right">0</td>
                            <td className="border border-black px-4 py-2 text-right">0</td>
                        </tr>
                        <tr>
                            <td className="border border-black px-4 py-2">खास पाणीपट्टी</td>
                            <td className="border border-black px-4 py-2 text-right">0</td>
                            <td className="border border-black px-4 py-2 text-right">0</td>
                            <td className="border border-black px-4 py-2 text-right">0</td>
                        </tr>
                        <tr className="font-bold">
                            <td className="border border-black px-4 py-2 text-right">एकुण</td>
                            <td className="border border-black px-4 py-2 text-right">0</td>
                            <td className="border border-black px-4 py-2 text-right">0</td>
                            <td className="border border-black px-4 py-2 text-right">0</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <style>
                {`
                    @media print {
                        @page {
                            margin: 1cm;
                        }
                        body {
                            print-color-adjust: exact;
                            -webkit-print-color-adjust: exact;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default TaxCollectionPrintReport;
